(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-c"] && !Shopify.designMode) return;
  try {
    
  class HeroCCarousel extends HTMLElement {
    connectedCallback() {
      this._slides = Array.from(this.querySelectorAll('.hero-c__slide'));
      if (this._slides.length <= 1) return;
      this._current = 0;
      this._timing = (parseFloat(this.dataset.timing) || 5) * 1000;
      this._transition = this.dataset.transition || 'fade';
      this._speed = parseFloat(this.dataset.speed) || 600;
      this._timer = setInterval(() => this._advance(), this._timing);
    }

    _advance() {
      const outgoing = this._slides[this._current];
      this._current = (this._current + 1) % this._slides.length;
      const incoming = this._slides[this._current];

      if (this._transition === 'fade') {
        outgoing.classList.remove('hero-c__slide--active');
        outgoing.setAttribute('aria-hidden', 'true');
        incoming.classList.add('hero-c__slide--active');
        incoming.setAttribute('aria-hidden', 'false');
      } else if (this._transition === 'swipe') {
        outgoing.style.transitionDuration = this._speed + 'ms';
        outgoing.classList.add('hero-c__slide--exit');
        outgoing.classList.remove('hero-c__slide--active');
        outgoing.setAttribute('aria-hidden', 'true');
        incoming.classList.add('hero-c__slide--active');
        incoming.setAttribute('aria-hidden', 'false');
        clearTimeout(this._cleanup);
        this._cleanup = setTimeout(() => {
          outgoing.style.transitionDuration = '';
          outgoing.classList.remove('hero-c__slide--exit');
        }, this._speed + 100);
      } else {
        outgoing.classList.add('hero-c__slide--exit');
        outgoing.classList.remove('hero-c__slide--active');
        outgoing.setAttribute('aria-hidden', 'true');
        incoming.classList.add('hero-c__slide--active');
        incoming.setAttribute('aria-hidden', 'false');
        clearTimeout(this._cleanup);
        this._cleanup = setTimeout(() => outgoing.classList.remove('hero-c__slide--exit'), this._speed + 100);
      }
    }

    disconnectedCallback() {
      clearInterval(this._timer);
      clearTimeout(this._cleanup);
    }
  }

  if (!customElements.get('hero-c-carousel')) {
    customElements.define('hero-c-carousel', HeroCCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-morgue"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function activateThumb(thumb) {
      var body = thumb.closest('.morgue-lightbox__body');
      if (!body) return;
      var img = body.querySelector('.morgue-lightbox__image');
      if (!img) return;
      img.src = thumb.getAttribute('data-full-src');
      img.srcset = thumb.getAttribute('data-full-srcset') || '';
      body.querySelectorAll('.morgue-lightbox__thumb').forEach(function (t) {
        t.classList.toggle('is-active', t === thumb);
      });
    }

    // Same "reopening should start at image 1" reset as the mobile carousel
    // (see swipe-carousel.liquid's resetSwipeCarousel), for the desktop
    // thumbnail-column view — without this it would keep showing whichever
    // image a thumbnail click last swapped in, across a close/reopen.
    function resetDesktopThumbs(dialog) {
      var thumbs = dialog.querySelectorAll('.morgue-lightbox__thumb');
      if (!thumbs.length) return;
      activateThumb(thumbs[0]);
      // A reopen can land mid-way through a previous swipe's slide
      // animation (its setTimeout still pending) — snap the image back to
      // its resting position so it doesn't show a leftover offset.
      var img = dialog.querySelector('.morgue-lightbox__image');
      if (img) {
        img.style.transition = 'none';
        img.style.transform = 'translateX(0)';
      }
    }

    // Swiping the main image in the desktop-view also advances/regresses
    // the active thumbnail, WITH the same live-drag-then-slide transition
    // as the portrait carousel (see swipe-carousel.liquid's nudgeTo/
    // commitDrag) — this view is what a phone in landscape actually shows
    // (most landscape phone widths cross the 750px breakpoint below), so it
    // needs to feel the same, not just click-to-select thumbnails. Real
    // desktop mouse users never fire touch events, so this is a no-op for
    // them. The desktop main area is a single <img>, not a multi-slide
    // track, so "sliding to the next image" here means: slide the CURRENT
    // image off screen, swap its src once that finishes, then slide the
    // NEW image in from the opposite side — same DRAG_MAX/DRAG_EASE/
    // DRAG_FIRE constants and 0.25s ease timing as the portrait carousel,
    // just choreographed across a src-swap instead of a translateX track.
    var DESKTOP_DRAG_MAX = 150;
    var DESKTOP_DRAG_EASE = 45;
    var DESKTOP_DRAG_FIRE = 30;
    var desktopSwipeStartX = null;
    var desktopSwipeStartY = null;
    var desktopSwipeDecided = false;
    var desktopSwipeHorizontal = false;
    var desktopSwipeImg = null;

    document.addEventListener(
      'touchstart',
      function (event) {
        var main = event.target.closest('.morgue-lightbox__main');
        if (!main || event.touches.length > 1) {
          desktopSwipeStartX = null;
          return;
        }
        desktopSwipeStartX = event.touches[0].clientX;
        desktopSwipeStartY = event.touches[0].clientY;
        desktopSwipeDecided = false;
        desktopSwipeHorizontal = false;
        desktopSwipeImg = main.querySelector('.morgue-lightbox__image');
      },
      { passive: true }
    );

    document.addEventListener(
      'touchmove',
      function (event) {
        if (desktopSwipeStartX === null || !event.touches[0] || !desktopSwipeImg) return;
        var dx = event.touches[0].clientX - desktopSwipeStartX;
        var dy = event.touches[0].clientY - desktopSwipeStartY;
        if (!desktopSwipeDecided) {
          desktopSwipeDecided = true;
          desktopSwipeHorizontal = Math.abs(dx) >= Math.abs(dy);
        }
        if (!desktopSwipeHorizontal) return;
        event.preventDefault();
        var nudge = (dx < 0 ? -1 : 1) * DESKTOP_DRAG_MAX * Math.tanh(Math.abs(dx) / DESKTOP_DRAG_EASE);
        desktopSwipeImg.style.transition = 'none';
        desktopSwipeImg.style.transform = 'translateX(' + nudge + 'px)';
      },
      { passive: false }
    );

    document.addEventListener('touchend', function (event) {
      var img = desktopSwipeImg;
      desktopSwipeImg = null;
      if (desktopSwipeStartX === null || !desktopSwipeHorizontal || !img) {
        desktopSwipeStartX = null;
        return;
      }
      var touch = event.changedTouches[0];
      var dx = touch ? touch.clientX - desktopSwipeStartX : 0;
      desktopSwipeStartX = null;

      var main = event.target.closest('.morgue-lightbox__main');
      var body = main && main.closest('.morgue-lightbox__body');
      var thumbs = body ? Array.prototype.slice.call(body.querySelectorAll('.morgue-lightbox__thumb')) : [];
      var activeIndex = 0;
      thumbs.forEach(function (t, i) {
        if (t.classList.contains('is-active')) activeIndex = i;
      });
      // Loops: past the last image wraps to the first, and back past the
      // first wraps to the last.
      var nextIndex = dx < 0 ? activeIndex + 1 : activeIndex - 1;
      nextIndex = (nextIndex + thumbs.length) % thumbs.length;
      var hasNext = thumbs.length > 1;

      if (Math.abs(dx) < DESKTOP_DRAG_FIRE || !hasNext) {
        // Spring back to resting position — either a short drag, or only
        // one image so there's nowhere to go.
        img.style.transition = 'transform 0.25s ease';
        img.style.transform = 'translateX(0)';
        return;
      }

      var exitX = dx < 0 ? '-100%' : '100%';
      var enterX = dx < 0 ? '100%' : '-100%';
      img.style.transition = 'transform 0.25s ease';
      img.style.transform = 'translateX(' + exitX + ')';

      window.setTimeout(function () {
        activateThumb(thumbs[nextIndex]);
        img.style.transition = 'none';
        img.style.transform = 'translateX(' + enterX + ')';
        void img.offsetWidth; // commit the off-screen position before animating back in
        img.style.transition = 'transform 0.25s ease';
        img.style.transform = 'translateX(0)';
      }, 250);
    });

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-morgue-lightbox-trigger]');
      if (trigger) {
        var dialog = document.getElementById(trigger.getAttribute('data-morgue-lightbox-trigger'));
        if (dialog) {
          var carouselRoot = dialog.querySelector('[data-swipe-carousel]');
          if (carouselRoot && carouselRoot.resetSwipeCarousel) {
            carouselRoot.resetSwipeCarousel();
          }
          resetDesktopThumbs(dialog);
          dialog.showModal();
          if (dialog.requestFullscreen) {
            dialog.requestFullscreen().catch(function () {});
          }
        }
        return;
      }

      var openDialog = event.target.closest('.morgue-lightbox');
      if (!openDialog || !openDialog.open) return;

      var closeBtn = event.target.closest('.morgue-lightbox__close');
      if (closeBtn) {
        openDialog.close();
        return;
      }

      var thumb = event.target.closest('.morgue-lightbox__thumb');
      if (thumb) {
        activateThumb(thumb);
        return;
      }

      // Anything else inside the open dialog that isn't the image itself
      // (the surrounding padding, the thumbnail column's background, etc.)
      // counts as "outside the image" and dismisses the lightbox.
      var onImage = event.target.closest('.morgue-lightbox__image, .swipe-carousel__image');
      if (!onImage) {
        openDialog.close();
      }
    });

    document.addEventListener('mouseover', function (event) {
      var thumb = event.target.closest('.morgue-lightbox__thumb');
      if (thumb) activateThumb(thumb);
    });

    // Swipe up or down (a vertical drag bigger than it is horizontal, past a
    // threshold) dismisses the lightbox — the standard mobile photo-viewer
    // gesture. Measured start-to-end on touchend, not during the drag, so it
    // never fights the carousel's own horizontal swipe-to-change-image.
    var verticalSwipe = null;

    document.addEventListener(
      'touchstart',
      function (event) {
        var dialog = event.target.closest('.morgue-lightbox');
        if (!dialog || !dialog.open || !event.touches[0]) return;
        // A second finger touching down means this is a pinch-to-zoom, not
        // a candidate swipe — drop any tracking so it can't be mistaken for
        // one later, even if a finger happens to drift vertically mid-pinch.
        if (event.touches.length > 1) {
          verticalSwipe = null;
          return;
        }
        verticalSwipe = { dialog: dialog, startX: event.touches[0].clientX, startY: event.touches[0].clientY };
      },
      { passive: true }
    );

    document.addEventListener(
      'touchend',
      function (event) {
        if (!verticalSwipe || !event.changedTouches[0]) return;
        // Fingers still down (e.g. lifting one finger out of a pinch) means
        // this isn't a completed single-finger swipe either.
        if (event.touches.length > 0) {
          verticalSwipe = null;
          return;
        }
        var dx = event.changedTouches[0].clientX - verticalSwipe.startX;
        var dy = event.changedTouches[0].clientY - verticalSwipe.startY;
        var dialog = verticalSwipe.dialog;
        verticalSwipe = null;
        if (Math.abs(dy) > Math.abs(dx) && Math.abs(dy) > 80) {
          dialog.close();
        }
      },
      { passive: true }
    );

    // Fires for Esc (native dialog behavior) and dialog.close() alike — one
    // place to exit fullscreen regardless of which way the lightbox closed.
    // 'close' does not bubble, so this must listen on the capture phase.
    document.addEventListener(
      'close',
      function (event) {
        var dialog = event.target;
        if (
          dialog.classList &&
          dialog.classList.contains('morgue-lightbox') &&
          document.fullscreenElement === dialog
        ) {
          document.exitFullscreen().catch(function () {});
        }
      },
      true
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
